import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from '../registru.service';
import { finalize } from 'rxjs';

@Component({
    selector: "app-add-registru",
    templateUrl: "./add-registru.component.html",
    styleUrls: ["./add-registru.component.scss"],
})
export class AddRegistruComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: "--Alegeți--",
        id: "-1",
    };

    tipuriMobilier: { name: string; id: string }[] = [
        { name: "--Alegeți--", id: "-1" },
        { name: "Chioșc", id: "1" },
        { name: "Terase", id: "2" },
        { name: "Lăzi frigorifice", id: "3" },
        { name: "Rastel", id: "4" },
        { name: "Aparat înghețată", id: "5" },
    ];

    form!: FormGroup;

    formAcordFunctionare: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        aviz_numar: new FormControl("", Validators.required),
        aviz_data: new FormControl(new Date(), Validators.required),
        f_sediu: new FormControl("", Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        obiect_activitate: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        orar_functionare: new FormControl("", Validators.required),
    });

    formAcordComercializare: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        aviz_numar: new FormControl("", Validators.required),
        aviz_data: new FormControl(new Date(), Validators.required),
        f_sediu: new FormControl("", Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        obiect_activitate: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        orar_functionare: new FormControl("", Validators.required),
    });

    formAcordTemporar: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        suprafata: new FormControl("", Validators.required),
        tip_mobilier: new FormControl("-1", [Validators.required, Validators.min(0)]),
    })

    formAutorizatieAlimentatiePublica: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        obiect_activitate: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
    });

    formAutorizatiePiata: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        f_sediu: new FormControl("", Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        nume_administrator: new FormControl("", Validators.required),
    });

    formAutorizatieRecreative: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        f_sediu: new FormControl("", Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        obiect_activitate: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
        suprafata: new FormControl("", Validators.required),
    })

    formAcordTeraseSezoniere: FormGroup = new FormGroup({
        document_numar: new FormControl("", Validators.required),
        document_data: new FormControl(new Date(), Validators.required),
        f_nume: new FormControl("", Validators.required),
        f_cui: new FormControl("", Validators.required),
        cerere_numar: new FormControl("", Validators.required),
        cerere_data: new FormControl(new Date(), Validators.required),
        f_punct_lucru: new FormControl("", Validators.required),
        valability: new FormControl(new Date(), Validators.required),
    })

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            registru_id: number;
            registru_slug: string;
        },
        private dialogRef: MatDialogRef<AddRegistruComponent>,
        private registruService: RegistruService,
        private notificationService: NotificationService,
    ) {
        this.initializeForm(this.data.registru_slug);
    }

    ngOnInit(): void { }

    initializeForm(registru_slug: string) {
        switch (registru_slug) {
            case 'acord-de-functionare':
                this.form = this.getFormAcordFunctionare();
                break;
            case 'acord-comercializare':
                this.form = this.getFormAcordComercializare();
                break;
            case 'acord-temporar':
                this.form = this.getFormAcordTemporar();
                break;
            case 'autorizatie-alimentatie-publica':
                this.form = this.getFormAlimentatiePublica();
                break;
            case 'autorizatie-piata-targ':
                this.form = this.getFormAutorizatiePiata();
                break;
            case 'autorizatie-recreative':
                this.form = this.getFormAutorizatieRecreative();
                break;
            case 'acord-terase-sezoniere':
                this.form = this.getFormAcordTeraseSezoniere();
                break;
            default:
                console.log("Not recognized");
        }
    }

    getFormAcordFunctionare(): FormGroup {
        return this.formAcordFunctionare;
    }
    getFormAcordComercializare(): FormGroup {
        return this.formAcordComercializare;
    }
    getFormAcordTemporar(): FormGroup {
        return this.formAcordTemporar;
    }
    getFormAlimentatiePublica(): FormGroup {
        return this.formAutorizatieAlimentatiePublica;
    }
    getFormAutorizatiePiata(): FormGroup {
        return this.formAutorizatiePiata;
    }
    getFormAutorizatieRecreative(): FormGroup {
        return this.formAutorizatieRecreative;
    }
    getFormAcordTeraseSezoniere(): FormGroup {
        return this.formAcordTeraseSezoniere;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const formData = { ...this.form.value };

        Object.keys(formData).forEach(key => {
            const value = formData[key];

            if (value instanceof Date) {
                formData[key] = value.toISOString();
                formData[`${key}_off`] = this.formatDate(value);
            }
        });

        // console.log(formData);

        this.registruService
            .addRegistruDocOficial(formData, this.data.registru_id)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }
}
